import React, { useEffect, ReactNode, useState } from 'react';
import swal from '@sweetalert/with-react';
import styled from 'styled-components';
import { ModalErrorIcon, ModalSuccessIcon, ModalWarningIcon } from '@/consts/svg-img';
import { Collapse } from 'antd';
import i18n from '@/i18n';

interface IProps {
  type: 'error' | 'success' | 'warning';
  content?: string;
  details?: string;
  title?: string;
  // text?: string;
  hideIcon?: boolean;
  footer?: ReactNode;
  timer?: number;
  onOk?: (...args: any[]) => any;
  destroyOthers?: boolean; // alignment to the DetailedModal
}

const VModalFunc = (props: IProps) => {
  const { type, onOk, content, details, title, hideIcon = false, footer, timer = 0 } = props;
  const getIcon = () => {
    switch (type) {
      case 'success':
        return <img src={ModalSuccessIcon} />;
      case 'error':
        return <img src={ModalErrorIcon} />;
      case 'warning':
        return <img src={ModalWarningIcon} />;
      default:
        return undefined;
    }
  };
  swal({
    buttons: {
      confirm: {
        text: 'OK',
        value: true,
        visible: true,
        className: 'swal-button',
        closeModal: true,
      },
    },
    closeOnClickOutside: false,
    content: (
      <ModalBody>
        {!hideIcon && <div className="v-modal-func__icon">{getIcon()}</div>}
        {title && <div className="v-modal-func__title">{title}</div>}
        {/* {text && <div className="v-modal-func__text">{text}</div>} */}
        {content && (
          <div
            className="v-modal-func__content"
            dangerouslySetInnerHTML={{ __html: content }}
          ></div>
        )}
        {details && (
          <Collapse className="v-modal-func__details">
            <Collapse.Panel header={i18n.t('common.details')} key="1">
              <div dangerouslySetInnerHTML={{ __html: details }}></div>
            </Collapse.Panel>
          </Collapse>
        )}
        {footer && <div className="v-modal-func__buttons">{footer}</div>}
      </ModalBody>
    ),
    timer: timer,
  }).then((value: string) => {
    console.log('modal func ok', value);
    if (value && onOk) {
      onOk();
    }
  });
};

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 120px;
  .v-modal-func {
    &__title {
      font-family: 'VFont-Bold';
      font-size: 18px;
      margin-top: 20px;
      text-align: center;
    }
    &__content {
      font-family: 'VFont';
      font-size: 14px;
      margin-top: 15px;
      color: #666666;
      text-align: center;
    }
    &__buttons {
      margin-top: 15px;
      display: flex;
      .not-first-child {
        margin-left: 15px;
      }
    }
    &__details {
      margin-top: 15px;
      text-align: left;
    }
  }
`;

export default VModalFunc;
